import './MainPage.css';
import React from "react";
import {IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs} from "@ionic/react";
import {home, map} from "ionicons/icons";
import {IonReactRouter} from "@ionic/react-router";
import Router from "../routers/Router";
import RouteService from "../services/routes/RouteService";
import CleanService from "../services/storage/localStorage/CleanService";
import { withTranslation, WithTranslation } from 'react-i18next';


/**
 * Page containing the main elements of the application such as routing, navigation and local storage.
 * @author Alizée Grand
 * @version 1.2
 * @creation 13/08/2021
 * @last_update 04/01/2022
 **/
class MainPage extends React.Component<WithTranslation> {

    /**
     * Is executed after the component output has been injected into the DOM.
     * Clean the storage when then component is mounted
     */
    componentDidMount() {
        CleanService.cleanStorageIfNecessary();
    }

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (
            <IonReactRouter>
                <IonTabs>
                    <IonRouterOutlet>
                        <Router/>
                    </IonRouterOutlet>
                    <IonTabBar slot="bottom" color="tertiary">
                        <IonTabButton tab="home" href={RouteService.getHome()}>
                            <IonIcon icon={home}/>
                            <IonLabel className="tabLabel">{getTranslation('tabs.home')}</IonLabel>
                        </IonTabButton>
                        <IonTabButton tab="map" href={RouteService.getMap()}>
                            <IonIcon icon={map}/>
                            <IonLabel className="tabLabel">{getTranslation('tabs.map')}</IonLabel>
                        </IonTabButton>
                    </IonTabBar>
                </IonTabs>
            </IonReactRouter>
        );

    }

}

export default withTranslation()(MainPage);
